import search from './search';
import reqs from './reqs';
import classes from './classes';

export default {
  search,
  reqs,
  classes,
};
